import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import TriggerDatePicker from './TriggerDatePicker';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

const WhenButtonGroup = () => {
    const { t } = useTranslation(NAMESPACES.AUTOMATIONS);

    return (
        <Container>
            <StyledLabel type="Body6DarkPrimary">
                {t('sidebar.when')}
            </StyledLabel>
            <TriggerDatePicker />
        </Container>
    );
};

export default observer(WhenButtonGroup);

const StyledLabel = styled(HBText)`
    display: block;
    margin-bottom: 10px;
`;

const Container = styled.div`
    padding: ${spacing[12]} 0;

    &:last-of-type {
        padding-bottom: ${spacing[4]};
    }
`;
